import { w as o } from "./addOns-5IZhcbHD.js";
const e = {
  id: "PuertoRicoPega3",
  logo: !0,
  name: "Pega 3",
  style: {
    colorPrimary: "#f04880",
    wildball: o
  }
};
export {
  e as default
};
